// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.allig-cancel-button .text-bold[data-v-68792bed] {\r\n  font-weight: bold;\n}\r\n", ""]);
// Exports
module.exports = exports;
